<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import {config} from "@/config";
export default {
  components: {
    DropDown,
    Notification,
  },
  emits: ['odjava'],

  data() {
    return {
      piloti: [],
      deaktivirani: [],
      pilotName: '',
      idPilota: '',
      dPilot: '',
      showSkupno: false,
      searchPilot: '',
      //NOTIFICATIONS
      text: '',
      types: '',
      ShowNoti: false,
      isLoading: false,
      user: config.FullUser,
    };
  },
  watch: {
    pilotName(star, nov) {
      if (star !== nov) {
        if (this.izbranMeni !== '') { //izpis pravic izvedemo samo, če je že izbran meni
          this.PraviceUporabnika();
        }
      }
    }
  },
  computed: {},

  mounted() {
    this.BeriPilote();
  },

  methods: {
    BeriPilote() {
      axios.get('./api/sifranti/piloti/izpis/', {withCredentials: true}).then((response) => {
        this.piloti = response.data.piloti;
        this.Deaktivirani();
      }).catch((napaka) => {
        this.text = napaka.response.data.napaka;
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Deaktivirani() {
      this.deaktivirani = this.piloti.filter(pilot => pilot.aktiven === false);
    },
    AktivirajUporabnika(id) {
      var podatki = new URLSearchParams();
      podatki.append('pID', this.deaktivirani[id].id);
      podatki.append('uEmail', this.deaktivirani[id].email);
      axios.post('./api/sifranti/piloti/uredi/reaktiviraj/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo;
        this.types = 'Uspešno';
        this.ShowNoti = true;
        var neaktivni = new Array;
        for (var i = 0; i < this.deaktivirani.length; i++) {
          if (i !== id) {
            neaktivni.push(this.deaktivirani[i]);
          }
        }
        setTimeout(() => {
          this.deaktivirani = neaktivni;
        }, 500);

      }).catch((napaka) => {
        if (napak.response.data !== undefined) {
          this.text = napaka.response.data.napaka;
        } else {
          this.text = napaka;
        }

        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    }
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>Nazaj</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">Deaktivirani uporabniki</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>
      </div>
    </div>
    <div class="section-content text-center" v-if="deaktivirani.length > 0">
      <p class='text-danger'>Ponovna aktivacija pilota, ki je bil izbrisan (deaktiviran).</p>
    </div>
    <div class="section-content text-center" v-else>
      <p class='text-danger'>Trenutno ni deaktiviranih pilotov za prikaz...</p>
    </div>
    <div class="form-section d-flex justify-content-between" v-for='(user, key) in deaktivirani'>
      <div class="section-header">
        <div class="section-icon">
          <i class="fas fa-user-times fa-lg"></i>
        </div>
        <div class="section-title">
          <h3>{{user.ime}} {{user.priimek}} [{{user.email}}]</h3>
        </div>
      </div>
      <div class='section-content'>
        <label class='switch col-6'>
          <input type='checkbox' v-model="deaktivirani[key].aktivnost" @change.prevent="AktivirajUporabnika(key)" :checked="user.aktivnost">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
  </div>
  <!-- </div> -->
  <div class="container">

    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false" />
    </Transition>
  </div>
  <div class='col-12 p-5'></div>
</template>